import { DownOutlined } from "@ant-design/icons"
import { Dropdown, Menu, Space, Typography } from "antd"
import React, { FC } from "react"
import { useAuth } from "../../../../../../../components/auth"
import { truncate } from "../../../../../../../utils"
import "./index.less"

const Filter: FC<EventFilterInterface> = ({ filters, setFilters, specificFilters, regionOptions }) => {
  const { region } = useAuth()
  const statusOptions = ["Past", "Ongoing", "Upcoming"].map((item, i) => ({ key: String(i), value: item, label: item }))

  const resetFilter = (type: string) => {
    switch (type) {
      case "title":
        setFilters({ ...filters, selectedTitle: "All" })
        break
      case "address":
        setFilters({ ...filters, selectedAddress: "All" })
        break
    }
  }

  const activeSpecificFiltersAmount = specificFilters.length

  return (
    <div className={`filters-wrapper events-filter`}>
      <div className={"filters"}>
        {!region?.id && (
          <Dropdown
            className={`region-filter ${filters.selectedRegion != "All" && "active"}`}
            trigger={["click"]}
            overlay={
              <Menu
                onClick={e =>
                  setFilters({ ...filters, selectedRegion: regionOptions.find(item => +item.key == +e.key)!.label! })
                }
                selectedKeys={[`${regionOptions.find(item => item.label == filters.selectedRegion)?.key ?? 0}`]}
              >
                {regionOptions.map(item => (
                  <Menu.Item key={item.key}>{item.label}</Menu.Item>
                ))}
              </Menu>
            }
          >
            <Typography.Link>
              <Space className={"dropdown"}>
                {truncate(regionOptions.find(item => item.label == filters.selectedRegion)?.label ?? "All", 18)}
                <DownOutlined style={{ color: "black" }} />
              </Space>
            </Typography.Link>
          </Dropdown>
        )}

        <Dropdown
          className={`status-filter ${filters.selectedStatus != "All" && "active"}`}
          trigger={["click"]}
          overlay={
            <Menu
              onClick={e =>
                setFilters({ ...filters, selectedStatus: statusOptions.find(item => +item.key == +e.key)!.label! })
              }
              selectedKeys={[`${statusOptions.find(item => item.label == filters.selectedStatus)?.key ?? "0"}`]}
            >
              {statusOptions?.map(item => <Menu.Item key={item.key}>{item.label}</Menu.Item>)}
            </Menu>
          }
        >
          <Typography.Link>
            <Space className={"dropdown"}>
              {statusOptions.find(item => item.label == filters.selectedStatus)?.label ?? "All"}
              <DownOutlined style={{ color: "black" }} />
            </Space>
          </Typography.Link>
        </Dropdown>
      </div>

      <div className={"specific-filters-wrapper"}>
        Filters ({activeSpecificFiltersAmount})
        <div className={"specific-filters-list"}>
          {specificFilters &&
            specificFilters.map((filter: any, i: number) => (
              <div
                className={"block"}
                key={`filter-${i}`}
                style={{ backgroundColor: filter.backgroundColor, color: filter.color }}
              >
                {truncate(filter.option, 32)}
                <div className={"remove-filter"} onClick={() => resetFilter(filter.type)}>
                  <div className={"l-line"} />
                  <div className={"r-line"} />
                </div>
              </div>
            ))}
        </div>
      </div>
    </div>
  )
}

export default Filter
